import { render, staticRenderFns } from "./xiaoyu.vue?vue&type=template&id=3d008dbb&scoped=true&"
var script = {}
import style0 from "./xiaoyu.vue?vue&type=style&index=0&id=3d008dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d008dbb",
  null
  
)

export default component.exports